import { isSameDay } from 'date-fns';
import React from 'react';

import { GanttYLabelElement } from './GanttYLabelElement';
import { GanttYLabelContainerProps } from './types';

export const GanttYLabelContainer: React.FC<GanttYLabelContainerProps> = ({
  currentDay,
  data,
  dayClassName,
  highlightedDate,
  t,
  timezone,
}) => (
  <div className="gantt-y-label__container" data-test-id="my-schedule:weekly-view:y-label-container">
    {data.map((day) => (
      <GanttYLabelElement
        {...{
          ...day,
          dayClassName,
          t,
          timezone,
          isHighlighted: !!highlightedDate && isSameDay(day.date, highlightedDate),
          isToday: isSameDay(currentDay, day.date),
          key: day.date,
        }}
      />
    ))}
  </div>
);
